import { useLocation } from "react-router-dom";

/**
 * Hook to get the canChangeName flag from the location state.
 * @returns The canChangeName flag or true if not defined
 */
export const useCanChangeName = () => {
  const location = useLocation();

  return location.state?.canChangeName ?? true;
}
